import { useCookies } from 'next-client-cookies';
import { getLocalizationInfo } from 'project.config';

const useI18n = () => {
   const cookies = useCookies();
    const locale = cookies.get('locale') as string;

  const config = getLocalizationInfo(locale);

  const country = config.countryCode;

  const currency = config.currency;

  const currencySymbol = config.currencyCode;
    
  const culture = config.locale;

  return { country, currency, currencySymbol,culture };
};

export default useI18n;
